import { Controller } from 'stimulus';
import qs from 'qs';
import axios from 'axios';
import formSerialize from 'form-serialize';
import debounce from '@/helpers/debounce';
import hasHistorySupport from '@/helpers/hasHistorySupport';
import toArray from '../helpers/toArray';

class VacanciesFilterController extends Controller {
  connect() {
    this.apiUrl = this.formTarget.action;
    this.isScrolled = false;
    this.filterDebounced = debounce(this.filter.bind(this), 150);

    this.checkFilterBarOffsetAndScroll = () => {
      this.checkFilterBarOffset();
      this.onWindowScroll();
      this.setVisibleState();
    };

    this.checkFilterBarOffsetAndScroll();

    window.addEventListener('resize', this.checkFilterBarOffsetAndScroll.bind(this));
    window.addEventListener('scroll', this.onWindowScroll.bind(this));
  }

  disconnect() {
    window.addEventListener('resize', this.checkFilterBarOffsetAndScroll.bind(this));
    window.removeEventListener('scroll', this.onWindowScroll.bind(this));
  }

  onFilterChange() {
    this.filterDebounced();
  }

  onWindowScroll() {
    const top = window.scrollY;

    if (top >= this.scrollOffset && !this.isScrolled) {
      this.isScrolled = true;
      this.setVisibleState();
    } else if (top < this.scrollOffset && this.isScrolled) {
      this.isScrolled = false;
      this.setVisibleState();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  onTabCloseClick({ currentTarget }) {
    const { tabId } = currentTarget.dataset;
    const tab = document.querySelector(`#${tabId}-tab`);
    const pane = document.querySelector(`#${tabId}`);

    tab.classList.remove('active');
    tab.setAttribute('aria-selected', false);
    pane.classList.remove('active');
  }

  async filter() {
    // Get all filters as key => value
    const parameters = formSerialize(this.formTarget, { hash: true });

    // Stringify the data object into a query string
    const stringified = qs.stringify(parameters, { encode: false });

    // Add question mark before stringified parameters
    const queryString = stringified !== '' ? `?${stringified}` : '';

    if (hasHistorySupport()) {
      // Get the full base url without any parameters
      const baseUrl = [window.location.protocol, '//', window.location.host, window.location.pathname].join('');

      try {
        // Output the query string after the baseUrl as GET parameters
        window.history.replaceState({}, '', `${baseUrl}${queryString}`);
      } catch (error) {
        // console.error(error);
      }
    }

    try {
      const { data } = await axios.get(`${this.apiUrl}${queryString}&count_only=1`);

      this.outputCount(data.count);
    } catch (error) {
      // console.error(error);
    }
  }

  outputCount(count) {
    const text = count === 1 ? `Toon ${count} vacature` : `Toon ${count} vacatures`;

    this.countTargets.forEach((countEl) => {
      countEl.innerText = text;
    });
  }

  checkFilterBarOffset() {
    this.scrollOffset = document.querySelector('#vacancies').offsetTop - 60;
  }

  setVisibleState() {
    this.element.classList[this.isScrolled ? 'add' : 'remove']('is-visible');
  }

  reset() {
    const formFields = toArray(this.formTarget.querySelectorAll('select, input'));

    if (!formFields.length) return;

    formFields.forEach((field) => {
      const defaultValue = typeof field.dataset.default !== 'undefined' ? field.dataset.default : '';

      if (field.type === 'checkbox') {
        field.checked = false;

        return;
      }

      field.value = defaultValue;
    });

    this.filterDebounced();
  }
}

VacanciesFilterController.targets = [
  'form',
  'count',
];

export default VacanciesFilterController;
